const getRedemptionAmount = (item) => {
  if (item.deal.customAmount && item.redemptionInputValue) {
    return item?.redemptionInputValue * 100;
  } else {
    return item.deal.redemptionValues[0];
  }
};

export default getRedemptionAmount;
